<template>
  <div v-if="bodyShow" class="case-analysis">
    <div class="case-bg"></div>
    <div v-for="(item,index) in list" :key="index">
      <!-- textarea -->
      <div v-if="item.type=='textarea'" class="case-list">
        <div class="content" v-html="item.question"></div>
        <!-- show_type 1、单行，2、多行。默认多行 -->
        <div :class="['input-flex',item.config.show_type==1?'single':'']" v-if="(!bool&& item.config.num>0)">
          <!--  -->
          <div :class="['input-group',(item.config.show_type==2 &&item.config.title&& item.config.title[childIdx].length>8)?'on':'']" v-for="(child,childIdx) in parseInt(item.config.num)" :key="childIdx">
            <span v-if="childIdx!=0">{{item.config.connection}}</span>
            <!-- 判断是否有标题 -->
            <div v-if="item.config.title" class="title">{{item.config.title[childIdx]}}</div>
            <!-- 多行并且标题超过8个长度换行 -->
            <input :readonly="item.config.type=='select'" @click="selectHandle(item.config.type,item.config.select,index,childIdx)" :placeholder="item.config.placeholder[childIdx]" type="text" v-model="item.val[childIdx]" />
            <img v-if="item.config.type=='select'" class="icon" src="@a/action-bottom.png" alt="">
          </div>
        </div>
        <!-- 解析 -->
        <div class="parsing-group" v-if="bool && item.result">
          <h5 v-if="item.config.type=='select'">
            <span v-for="(subItem,subIdx) in subfield[item.id].content" :key="subIdx">{{subItem}}<span v-if="subIdx==0">{{item.config.connection}}</span></span>
          </h5>
          <!-- subfield已经提交过的数据 -->
          <h5 v-for="(pItem,pIdx) in item.config.title" :key="pIdx">{{pItem}}：{{subfield[item.id]&&subfield[item.id].content?subfield[item.id].content[pIdx]:''}}</h5>
        </div>
        <div v-if="bool && item.result" class="parsing">
          <!-- <img class="da" v-if="subfield[item.id].imgLink" :src="subfield[item.id].imgLink" width="100%" alt=""> -->
          <div v-html="item.result"></div>
        </div>
      </div>
      <!-- radio -->
      <div v-if="item.type=='radio'" class="case-list">
        <div class="content" v-html="item.question"></div>
        <!-- 是否已解析 -->
        <div v-if="!bool">
          <div class="identity-group" v-for="(itm,idx) in item.answer" :key="idx">
            <label :class="['icon',itm.str_id==item.val?'on':'']" :for="itm.str_id">
              <input :id="itm.str_id" @change="radioChange()" type="radio" :value="itm.str_id" v-model="item.val[0]" />
            </label>
            <label :for="itm.str_id">{{itm.str_id+itm.str}}</label>
          </div>
          <div class="input-flex" v-for="(child,childIdx) in parseInt(item.config.num)" :key="childIdx">
            <input v-for="child in parseInt(item.config.num)" :placeholder="item.config.placeholder[child-1]" :key="child" type="text" v-model="item.other[childIdx]" />
          </div>
        </div>
        <!-- 解析 -->
        <div v-if="bool && item.result" class="parsing-radio">
          <h3 v-if="item.val[0]">选项：{{item.val[0]}}</h3>
          <p>理由：<span v-for="(child,childIdx) in parseInt(item.config.num)" :key="childIdx">{{item.other[childIdx]}}</span></p>
          <div v-html="item.result" class="parsing"></div>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <a v-if="!bool" @click="submitHandle()" class="submitBtn">提交</a>
    <div v-else class="btn-group">
      <a @click="updataShow = true" class="nextTask1">我要做的更好</a>
      <!-- 判断是否是未解锁还是已通关 -->
      <!-- 未解锁 -->
      <div class="nextTask1 nextTask nextTask_lock" v-if="!classes_obj.bool">
        {{classes_obj.val}}
      </div>
      <!-- 已通关 -->
      <a class="nextTask1 nextTask" v-else-if="next.last">恭喜你 你通关了哟</a>
      <a v-else class="right-next">
        <a class="nextTask1 nextTask nextTask_lock" v-if="next.complete">开始挑战任务</a>
        <a v-else>
          <a v-if="next.same" @click="list_link()">
            <a v-if="next.data.type == 1">开启“测评”</a>
            <a v-else-if="next.data.type == 2">开启下一课程</a>
            <a v-else-if="next.data.type == 3">开始挑战任务</a>
            <a v-else-if="next.data.type == 5">开启“案例分析”</a>
          </a>
          <a @click="list_link()" class="nextTask1 nextTask" v-else>挑战下一关</a>
        </a>
      </a>
    </div>
    <!-- 确认提交弹窗 -->
    <van-popup class="case-pop" v-model="updataShow">
      <div class="case-box">
        <h2>是否确认重新填写？</h2>
        <div class="btn_group">
          <a class="confirm on" href="javascript:;" @click="editCase()">确认</a>
          <a class="cancel" href="javascript:;" @click="updataShow=false">取消</a>
        </div>
      </div>
    </van-popup>
    <!-- 兴趣特征 -->
    <van-popup position="bottom"  v-model="interestShow">
      <van-picker  show-toolbar :columns="interestArr" :default-index="0"   @cancel="interestShow=false" @confirm="interestCfm" />
    </van-popup>
    <!-- 关卡介绍 -->
    <public-level :level_list_id="level_list_id"></public-level>
    <!-- 引入返回列表页面 -->
    <capacity-fixed v-if="bool" :cid="$route.query.cid"></capacity-fixed>
  </div>
</template>
<script>
import CapacityFixed from "@c/course/capacity-fixed"
import PublicLevel from '@c/course/public-level'
import { explainTest, testSubmit} from "@/api/course";
import { shareCon} from "@/utils/wxconfig";
import Bus from "@/utils/bus";
import {dateFormat} from '@/utils/tools'
export default {
  data() {
      return {
        bodyShow: false,
        list: [],
        bool: false,
        subfield: {},
        next: {},
        updataShow: false,
        interestArr:[], // 下拉选项值
        interestShow:false,
        interestIndex:null,
        childIdx:null,
        level_list_id:'',
        // 是否开课
        classes_obj:{
          bool:true,
          val:''
        }
      }
    },
    components: {
      CapacityFixed,
      PublicLevel
    },
    methods: {
      preventDefault(e) {
        e.preventDefault();
      },
      /*
       *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-28 12:18:35
      */
      pickerShowClick(newval) {
        let self = this;
        if (newval) {
          document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //阻止默认事件
        } else {

          document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
            passive: false
          }); //打开默认事件
        }
      },
      /*
       *@param: 
       *@return: 
       *@Description: 确认选项
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-04 15:22:21
      */
      interestCfm(val){
        this.list[this.interestIdx].val[this.childIdx]=val;
        this.interestShow = false;
      },
      /*
       *@param: type,selectArr
       *@return: 
       *@Description: 下拉选项
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-04 15:08:24
      */
      selectHandle(type,selectArr,index,childIndex){
        if(type=='select'){
          this.interestArr = selectArr[childIndex];
          this.interestIdx = index;
          this.childIdx = childIndex;
          this.interestShow = true;
        }else{
          return
        }
      },
      /*
       *@Description: 重新填写
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-25 17:58:06
       */
      editCase() {
        // 下边是清空数据
        // this.list.forEach((item, index) => {
        //   // 初始化默认值
        //   item.val = [];
        //   if (item.type == 'textarea' && parseInt(item.config.num) > 0) {
        //     // 循环给数组初始化
        //     for (let i = 0; i < parseInt(item.config.num); i++) {
        //       item.val[i] = ''
        //     }
        //   }
        //   if ((item.type == 'radio' || item.type == 'checkbox') && parseInt(item.config.num) > 0) {
        //     item.other = [];
        //     // 循环给数组初始化
        //     for (let i = 0; i < parseInt(item.config.num); i++) {
        //       this.$set(item['other'], i, '');
        //     }
        //   }
        // });
        this.updataShow = false;
        this.bool = false;
      },
      /*
       *@Description: <!-- 内容类型 1测评 2音频 3任务 4小组讨论 5案例 -->
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-25 17:54:29
       */
      list_link() {
        let item = this.next.data;
        if (item.type == 1) {
          window.location.href = item.link;
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid +'&level_list_id=' + item.id+ '&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          // 是否完成当前任务，已完成跳转报告页面
          if(item.complete){
            this.$router.push('project_report?cid=' + item.cid +'&level_list_id=' + item.id+ '&cpid=' + item.cpid + '&taskid=' + item.table_id+'&name=' + this.next.level_name)
          }else{
            this.$router.push(item.link + '?cid=' + item.cid + '&level_list_id=' + item.id+ '&pid=' + item.cpid + '&id=' + item.table_id+'&name=' + this.next.level_name)
          }
          // this.$router.push(item.link + '?cid=' + item.cid + '&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id +'&level_list_id=' + item.id+ '&cid=' + item.cid)
        }
      },
      // 实时更新
      radioChange() {
        this.$forceUpdate();
      },
      /*
       *@param:
       *@return: 提交数据
       *@Description:
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-25 11:43:20
       */
      submitHandle() {
        if (!this.validationHandle()) {
          this.$toast('数据信息不能为空！');
        } else {
          this.$toast.loading({
            mask: true,
            message: "提交中..."
          });
          let arr = [];
          this.list.forEach((item, index) => {
            if ((item.type == 'radio' || item.type == 'checkbox') && parseInt(item.config.num) > 0) {
              arr.push({
                id: item.id,
                content: JSON.stringify({
                  title: item.val,
                  value: item.other
                })
              });
            } else {
              arr.push({
                id: item.id,
                content: JSON.stringify(item.val)
              });
            }
          });
          testSubmit({
            id: this.$route.query.id,
            cid: this.$route.query.cid,
            field: arr
          }).then((data) => {
            if (data.code == 10002) {
              this.$toast(data.msg);
              return;
            }
            this.$toast(data.msg);
            this.pullData();
            this.$toast.clear();
          });
        }
      },
      /*
       *@param:
       *@return:
       *@Description: 验证数据格式
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-25 10:47:39
       */
      validationHandle() {
        let bool = true;
        this.list.forEach((item, index) => {
          if (item.type == 'textarea') {
            for (let i = 0; i < parseInt(item.config.num); i++) {
              if (item.val[i] == '') {
                bool = false;
              }
            }
          }
          if ((item.type == 'radio' || item.type == 'checkbox')) {
            if (item.val == '') {
              bool = false;
            }
            if (parseInt(item.config.num) > 0) {
              // 循环给数组初始化
              for (let i = 0; i < parseInt(item.config.num); i++) {
                if (item.other[i] == '') {
                  bool = false;
                }
              }
            }

          }
        });
        return bool;
      },
      /*
       *@Description: 数据请求
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-25 10:46:56
       */
      pullData() {
        // 获取关卡信息
        let q = this.$route.query;
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        explainTest({
          id: this.$route.query.id
        }).then(data => {
          if (data.code == 10002) {
            this.$toast(data.msg);
            return;
          }
          this.list = data.list;
          this.next = data.next;
          // 计算日期大小，判断是否有下一关或者未解锁
          this.dataSize();
          if (this.next instanceof Array && this.next.length == 0) {
            this.$toast("配置错误");
            return
          }
          this.bool = data.subfield && data.subfield.length > 0;
          this.list.forEach((item, index) => {
            // 处理subfield数据
            if (data.subfield && data.subfield.length > 0) {
              data.subfield.forEach((sitem, sindex) => {
                if (item.id == sitem.field_id) {
                  this.subfield[item.id] = {
                    content: sitem.content?sitem.content:'',
                    imgLink: sitem.img
                  };
                  if (item.type == 'radio' || item.type == 'checkbox') {
                    // 判断正式测试数据格式修改数据展示方式
                    if(sitem.content.title){
                      item.val = sitem.content.title;
                      item.other = sitem.content.value;
                    }else{
                      item.val = sitem.content;
                      item.other = sitem.content;
                    }
                  } else {
                    item.val = sitem.content;
                  }
                }
              });
              if((item.type == 'radio' || item.type == 'checkbox')){
                item.val = !item.val?[]:item.val;
                item.other = !item.other?[]:item.other;
              }else{
                item.val = !item.val?[]:item.val;
              }
            } else {
              // 初始化默认值
              item.val = [];
              if (item.type == 'textarea' && parseInt(item.config.num) > 0) {
                // 循环给数组初始化
                for (let i = 0; i < parseInt(item.config.num); i++) {
                  item.val[i] = ''
                }
              }
              if ((item.type == 'radio' || item.type == 'checkbox') && parseInt(item.config.num) > 0) {
                item.other = [];
                // 循环给数组初始化
                for (let i = 0; i < parseInt(item.config.num); i++) {
                  this.$set(item['other'], i, '');
                }
              }
            }

          });
          this.bodyShow = true;
          this.$toast.clear();
        });
      },
      /*
       *@param: 
       *@return: 
       *@Description: 比较日期时间大小
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-23 10:08:27
      */
      dataSize(){
        if(this.next.unlock_time){
          // 获取开课时间
          let d = dateFormat('yyyy-MM-dd hh:mm:ss',new Date(this.next.unlock_time*1000));
          let arr = d.split(' ');
          let date_ = arr[0].replace(/-/g, '');
          let time_ = arr[0].replace(/:/g, '');
          // 获取当前时间
          let date =new Date();
          let rq = String(date.getFullYear())+String(date.getMonth()+1)+String(date.getDate());
          let time = String(date.getHours())+String(date.getMinutes())+String(date.getSeconds());
          // 如果开课日期大于当前日期
          if(date_>rq || (date_==rq && time_>time)){
            this.classes_obj.bool=false;
            this.classes_obj.val='暂未解锁下一关卡';
            
          }
        }
        
      }
    },
    created() {
      Bus.$on('documentTitle',(data)=>{
        document.title = data.level.name;
      });
      // 分享
      shareCon("course", this);
      this.pullData();
    }
};
</script>
<style lang="scss">
.case-analysis {
  padding: 50px 30px 178px;
  .case-bg {
    background: linear-gradient( -90deg, rgba(245, 127, 23, 1), rgba(235, 80, 50, 1));
    height: 174px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .case-list {
    background-color: #ffffff;
    margin-bottom: 20px;
    padding: 40px 30px;
    border-radius: 12px;
  }
  .content {
    img {
      width: 100% !important;
    }
  }
  .parsing-group{
    font-size: 28px;
    .parsing-h4{
      margin-bottom: 30px;
      color: #F57F17;
      line-height: 42px;
    }
    h5{
      font-size: 28px;
      color: #333333;
      margin-bottom: 20px;
      line-height: 40px;
    }
  }
  
  .input-flex {
    display: flex;
    flex-direction: column;
    .input-group {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-bottom: 20px;
      position: relative;
      &:last-child {
        margin-bottom: 0;
      }
      div.title{
        font-size: 28px;
        color: #F57F17;
        margin-right: 12px;
      }
      .icon{
        width: 27px;
        height: 16px;
        position: absolute;
        right: 20px;
      }
    }
    .input-group.on{
      flex-direction: column;
      .title{
        margin-right: auto;
        margin-bottom: 10px;
      }
    }
    input {
      border: 2px solid #cccccc;
      box-sizing: border-box;
      border-radius: 8px;
      padding: 0 20px;
      line-height: 70px;
      width: 100%;
      flex: 1;
    }
  }
  .input-flex.single {
    flex-direction: row;
    .input-group {
      margin-bottom: 0;
      span {
        display: block;
        line-height: 70px;
        text-align: center;
        width: 62px;
      }
    }
  }
  .identity-group {
    display: flex;
    color: #333333;
    align-items: center;
    margin-bottom: 26px;
    font-size: 32px;
    &:last-child {
      margin-bottom: 0;
    }
    label.icon {
      display: block;
      position: relative;
      width: 40px;
      height: 40px;
      border: 2px solid #cccccc;
      background-color: #ffffff;
      border-radius: 50%;
      margin-right: 20px;
      input[type="radio"] {
        display: none;
        border: 0;
        outline: 0 !important;
        background-color: transparent;
        -webkit-appearance: none;
      }
    }
    label.icon.on {
      background-color: #eb5032;
      &:after {
        display: block;
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 20px;
        height: 20px;
        background-color: #ffffff;
        border-radius: 50%;
      }
    }
  }
  .submitBtn {
    line-height: 98px;
    width: 100%;
    position: fixed;
    z-index: 666;
    left: 50%;
    max-width: 750px;
    transform: translateX(-50%);
    bottom: 0;
    background-color: #eb5032;
    color: #ffffff;
    font-size: 34px;
  }
  .btn-group {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    line-height: 98px;
    width: 100%;
    position: fixed;
    z-index: 666;
    left: 50%;
    max-width: 750px;
    transform: translateX(-50%);
    bottom: 0;
    background-color: #EB5032;
    a{
      display: block;
    }
    .nextTask1 {
      font-size: 34px;
      text-align: center;
      flex: 1;
      color: #ffffff;
      border-right: 1px solid #fff;
    }
    .nextTask {
      color: #ffffff;
      margin-left: auto;
      border-right: 0;
    }
    .nextTask_lock {
      background-color: #ccc;
      border-right: 0;
    }
    .right-next{
      font-size: 34px;
      text-align: center;
      flex: 1;
      color: #ffffff;
      margin-left: auto;
      border-left: 1px solid #fff;
      border-right: 0;
    }
  }
  .parsing {
    margin-top: 50px;
    border-top: 2px dashed #cccccc;
    .da{
      margin-top: 30px;
    }
    img{
      width: 100%;
    }
  }
  .parsing-radio {
    h3 {
      font-size: 28px;
      color: #333333;
      margin-bottom: 30px;
    }
    p {
      line-height: 42px;
      font-size: 28px;
      color: #333333;
    }
  }
  /* 确认弹窗 */
.case-box{
    width: 476px;
    color: #333;
    border-radius:8px;
    font-size:34px;
    overflow: hidden;
    background-color: #fff;
}
.case-box h2{
    font-size:34px;
    font-weight: normal;
    text-align: center;
    padding: 45px 80px;
}
.case-box .btn_group{
    width: 100%;
    font-size: 0;
    display: flex;
    align-items: center;
    border-top:1px solid rgba(204,204,204,1);
    line-height: 94px;
}
.case-box .btn_group a.cancel{
    flex: 1;
    font-size: 34px;
    color: #999999;
    text-align: center;
    height: 100%;
}
.case-box .btn_group a.confirm{
    flex: 1;
    font-size: 34px;
    color: #EB5032;
    text-align: center;
    height: 100%;
}
.case-box .btn_group a.on{
    border-right:1px solid rgba(204,204,204,1);
}
.case-pop{
    background-color: transparent;
}
}
</style>
<style lang="scss">
  .parsing img{
    width: 100%;
  }
</style>